<template>
    <div class="u-page-wrapper pb-56">
        <div class="u-page-headline pb-8 u-flex u-flex--space-between u-flex--vertical-center">
            <h2 class="u-size-body">
                <i class="el-icon-question" aria-hidden="true"></i>
                FAQs
            </h2>
        </div>

        <el-collapse v-model="activeCollapsible" accordion>
            <el-collapse-item title="Waschanlage" name="1">
                <span class="text-warning">Bei ausgeschaltetem Motor:</span><br>
                - In den Freilauf wechseln<br><br>
                <span class="text-warning">Bei angeschaltetem Motor:</span><br>
                <ul>
                    <li>- Bremsassistent ausschalten</li>
                    <li>- Start/Stop ausschalten</li>
                    <li>- Schweibenwisch-Automatik ausschalten</li>
                    <li>- Einparkhilfe ausschalten (nur vorne)</li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="Wechsel in den Freilauf" name="2">
                <ul class="mb-16">
                    <li>Wählhebel bei stehendem Fahrzeug und laufendem Motor in den Modus N stellen. Zündung ausschalten.</li>
                    <li class="mt-16 u-bold">Innerhalb von 5 Sekunden:</li>
                    <li>1. Zündung erneut einschalten (nicht den Motor, also Fuß runter von der Bremse).</li>
                    <li>2. Bremspedal ganz durch treten und Wählhebel nach vorne oder nach hinten bewegen, um den Modus N zu bestätigen.</li>
                    <li>3. Bremspedal ganz durch drücken und dabei Betätigungsschalter(?) drücken, um die Feststellbremse zu lösen.</li>
                    <li>4. Bremspedal loslassen und Zündung ausschalten. Wenn die Zeitspanne von 5 Sekunden überschritten wird, bleibt das Getriebe im Modus P. Dann muss der Vorgang wiederholt werden.</li>
                </ul>

                <span class="u-bold">Deaktivierung</span>: Bremspedal durchtreten und Motor starten.
            </el-collapse-item>
            <el-collapse-item title="Autom. elektr. Handbremse abstellen" name="3">
                <ul class="mb-16">
                    <li>1. Motor einschalten</li>
                    <li>2. Feststellbremse anziehen</li>
                    <li>3. Fuß vom Bremspedal nehmen</li>
                    <li>4. Den Betätigungsschalter der Feststellbremse in Richtung Lösen mindestens 10 Sekunden und höchstens 15 Sekunden lang gedrückt halten</li>
                    <li>5. Betätigungsschalter loslassen</li>
                    <li>6. Betätigungsschalter loslassen</li>
                    <li>7. Bremspedal drücken und gedrückt halten</li>
                    <li>8. Zwei Sekunden lang den Betätigungsschalter in Richtung Anziehen der Feststellbremse gedrückt halten</li>
                </ul>

                Fürs Deaktivieren wiederholen.
            </el-collapse-item>
            <el-collapse-item title="Breamsassistent abstellen" name="4">
                Wird über das "Fahrbeleuchtung / Fahrzeug" Touchscreen-Menü eingestellt
            </el-collapse-item>
            <el-collapse-item title="Start/Stop abstellen" name="5">
                Wird über das Touchscreen-Menü "Fahrbeleuchtung / Fahrzeug" eingestellt
            </el-collapse-item>
            <el-collapse-item title="Zwei Smartphones verbinden" name="6">
                Ein Smartphone soll für Anrufe und die App verbunden sein, das andere nur für Musik-Streaming:

                <ul class="mt-8">
                    <li>1. Verbinde das Handy für Anrufe und App</li>
                    <li>2. Klicke auf die Touch-Taste mit dem Telefon</li>
                    <li>3. Klicke neben dem verbundenen Handy auf das Icon</li>
                    <li>4. Wähle "Musik Streaming" ab</li>
                    <li>5. Verbinde das zweite Handy</li>
                    <li>6. Falls nötig, hake "Musik Streaming" für dieses Gerät an</li>
                </ul>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    name: 'Faqs',

    data: () => ({
        activeCollapsible: null,
    }),
}
</script>

<style lang="scss" scoped>
/deep/ .el-collapse {
    border-top: none;

    .el-collapse-item__header,
    .el-collapse-item__wrap,
    .el-collapse-item__content {
        background: transparent;
        color: $white;
    }

    .el-collapse-item__header {
        color: $primary-color;
        font-size: $font-size-16;
        font-weight: $font-weight-bold;
    }

    .el-collapse-item__content {
        font-size: $font-size-16;
    }
}
</style>
